import { authActionTypes } from '../types';
import { AuthReducer, IAction } from 'src/interfaces';

const initialState = {
  isAuthenticated: false,
  isAuthenticating: true,
  unauthorizedError: false,
  redirectInProgress: false
};

export default (state = initialState, { type, payload }: IAction): AuthReducer => {
  switch (type) {
    case authActionTypes.PUT_USER:
      return {
        ...state,
        unauthorizedError: false,
        isAuthenticated: true,
        isAuthenticating: false
      };

    case authActionTypes.SET_AUTHENTICATED:
      return { ...state, unauthorizedError: false, isAuthenticated: payload };

    case authActionTypes.SIGN_OUT:
      return { ...state, isAuthenticated: false, isAuthenticating: false };

    case authActionTypes.REFRESH_ERROR:
      return { ...state, isAuthenticated: false, isAuthenticating: false };

    case authActionTypes.UNAUTHORIZED_ERROR:
      return { ...state, unauthorizedError: true };

    case authActionTypes.SET_REDIRECT_IN_PROGRESS:
      return { ...state, redirectInProgress: payload };

    default:
      return state;
  }
};
